// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"306":"236fbf20","340":"72d652a0","526":"ebbbf255","556":"b245fb0f","706":"646c3f6b"}[chunkId] + ".js";
};